import { Trans } from "@lingui/macro";
import { FailureApi } from "@smp/api";
import { UiModuleLoader } from "@smp/ui";
import { FC, PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { ContextProviderEp } from "@/context/ep";
import { ContextProviderSmp } from "@/context/smp";
import { useEpUsersMe } from "@/hooks/use_ep_users_me";
import { ContextProviderApp } from "@/screens/app/context/app";
import { ProviderGA } from "@/screens/app/context/ga";
import { ProviderPostConstructorOpener } from "@/screens/app/context/post_constructor_opener";
import { ProviderWindowMessage } from "@/screens/app/context/wm";
import { ProviderWebStomp } from "@/screens/app/context/ws";
import { redirector } from "@/utils";

import {
  Drawer,
  DrawerMock,
  Header,
  HeaderMock,
  Viewport,
  ViewportMock,
} from "./components";
import classes from "./layout.module.css";

export interface ILayoutProps {
  isAuthReuired: boolean;
}

export const Layout: FC<PropsWithChildren<ILayoutProps>> = ({
  isAuthReuired,
  children,
}) => {
  const { me, meError, isMeFetched } = useEpUsersMe();

  if (!isMeFetched && !import.meta.env.SSR) {
    return <UiModuleLoader loadingText={<Trans>Loading</Trans>} />;
  }

  if (
    isAuthReuired &&
    meError instanceof FailureApi &&
    meError.code === "API__INTERNAL__401_UNAUTHORIZED"
  ) {
    return <Navigate to={redirector.getAuthLocation()} />;
  }

  if (!me || import.meta.env.SSR) {
    return (
      <div className={classes.root}>
        <ViewportMock>{children}</ViewportMock>
        <HeaderMock />
        <DrawerMock />
      </div>
    );
  }

  return (
    <ContextProviderSmp>
      <ContextProviderEp>
        <ContextProviderApp>
          <ProviderWebStomp>
            <ProviderPostConstructorOpener>
              <ProviderGA />
              <ProviderWindowMessage />

              <div className={classes.root}>
                <Viewport>{children}</Viewport>
              </div>
              <Header />
              <Drawer />
            </ProviderPostConstructorOpener>
          </ProviderWebStomp>
        </ContextProviderApp>
      </ContextProviderEp>
    </ContextProviderSmp>
  );
};
